import {IcnChevronDown} from "../../assets/icons";

import { ButtonHTMLAttributes, ReactNode } from "react";
import {cButtonProps} from "../../utils";
import clsx from "clsx";

export interface ButtonProps extends cButtonProps, ButtonHTMLAttributes<HTMLButtonElement> {
  type?: "submit" | "reset";
  extraClassName?: string;
  title?: string;
  text?: string;
  addChevronIcon?: boolean;
  children?: ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  isLoadingText?: string;
}

function Button(
  {
    type,
    extraClassName,
    text,
    title,
    children,
    btnColor,
    btnVariant,
    btnSize,
    icon,
    iconPlacement,
    addChevronIcon,
    onClick,
    isLoading,
    isLoadingText,
    ...props
  }: ButtonProps) {

  return (
    <button
      type={type ? type : "button"}
      className={clsx("c-button", extraClassName && extraClassName)}
      title={title ?? text ?? "Button Title"}
      aria-label={title ?? text ?? "Button Title"}
      data-color={btnColor && btnColor}
      data-variant={btnVariant && btnVariant}
      data-size={btnSize && btnSize}
      data-icon-placement={iconPlacement && iconPlacement}
      onClick={onClick}
      {...props}
    >
      {isLoading? (
        <span>{isLoadingText || "Loading"}<span className="c-button-loader"></span></span>
      ) : text? (
        <span>{text}</span>)
        : children
      }
      {icon && <i>{icon}</i>}

      {addChevronIcon && (
        <i className="c-button-icon-chevron">
          <IcnChevronDown />
        </i>
      )}

    </button>
  )
}

export default Button
